<div class="d-flex align-items-center">
    @if (showSelectAll) {
        <span class="ms-2">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="selectAllUniqueId" [(ngModel)]="isSelectAll" (change)="selectAllChanged()">
            <label class="form-check-label" [for]="selectAllUniqueId">{{'global.select.all.items' | translate}}</label>
        </div>
    </span>
    }
    @if (selectedItemsSize > 0 || isSelectAll) {
        <span class="ms-2"
              [ngbPopover]="popContent"
              popoverClass="items-selected-popover"
              triggers="mouseenter:mouseleave"
              placement="bottom">
        <span class="badge rounded-pill bg-secondary fs-6">{{  isSelectAll ? totalItemsSize : selectedItemsSize }}</span><span class="ms-1">{{'global.deselect.items.selected' | translate}}</span>
        </span>
        <span class="ms-2">
            <button class="btn btn-outline-info btn-sm" (click)="deselectAll()"><i class="fa fa-square-xmark"></i> {{'global.deselect.all.items' | translate}}</button>
        </span>
    }
</div>

<!-- Popover template -->
<ng-template #popContent>
    <div>
        <span class="fw-bold">{{'global.selection.instruction.title' | translate}}</span><br>
        <ul>
            <li>{{'global.selection.instruction.item1' | translate}}</li>
            <li>{{'global.selection.instruction.item2' | translate}}</li>
            <li>{{'global.selection.instruction.item3' | translate}}</li>
        </ul>
    </div>
</ng-template>
